<template>
  <div>
      <slot></slot>
      <div v-if="focus && focus.state === 'ondeck'">
        <div style="display: flex; align-items: center; margin-bottom: 16px">
          <div style="font-size: 12px; margin-right: 12px">
            Select measurement system
          </div>
          <div style="padding-right: 0" >
            <button style="font-size: 10px" :aria-pressed="measureSystem === 'metric'" @click="measureSystem = 'metric'">
              Metric
            </button>
            <button style="font-size: 10px" :aria-pressed="measureSystem === 'us'" @click="measureSystem = 'us'">
              US
            </button>
          </div>
        </div>
        <div style="display: flex">
          <div style="font-size: 12px; margin-right: 12px">
            What you will measure
          </div>
        </div>
        <div style="display: flex">
          <div>
            <vue-bootstrap-typeahead
                id="type-measure-text"
                v-model="typeToMeasure"
                no-resize
                :data="typeToMeasureData"
                placeholder="weight/height/calves"
                ref="typeToMeasure"
            />
          </div>
          <div>
            <vue-bootstrap-typeahead
                id="unit-measure-text"
                v-model="measureUnit"
                no-resize
                :data="unitTypeData"
                placeholder="centimeter/feet/kilogram/etc"
                ref="measureUnit"
            />
          </div>
          <div style="flex:1">
            <button @click="handleAddMeasureSetting">Add</button>
          </div>
        </div>
        <div class="mt-3" v-if="tool && tool.settings && tool.settings.measures">
          <!-- {{tool}} -->
          <div style="display: flex; margin-bottom: 12px" v-for="(measure,index) in tool.settings.measures" :key="index">
            <span style="text-transform: capitalize">{{measure.type}}</span>: {{measure.in}}
          </div>
        </div>
      </div>


      <div v-if="focus && focus.state === 'ontrack'">
        <div>
          <div style="display: flex; margin-bottom: 12px; align-items: center; border: 1px solid #e7e8e8; border-radius:10px; height: 35px" v-for="(measure,index) in measureSettings" :key="index">
            <div>
              {{measure.type}}
            </div>
            <div>
              <b-input v-model="measureValues[index]" type="number" style="width: 70px; border:none; border-bottom: 1px solid #e8e9e9; font-size: 12px; height: 20px" />
            </div>
            <div>
              {{measure.in}}
            </div>
          </div>
          <div style="display: flex">
            <button style="width: 100%" @click="handleSaveTrack" :disabled="measureValues.includes(null) || measureValues.includes('')">Update</button>
          </div>
        </div>
      </div>


      <div v-if="focus && focus.state==='stationed'">
        <div>
          <div style="display: flex; margin-bottom: 12px; align-items: center; border: 1px solid #e7e8e8; border-radius:10px; height: 35px" v-for="(measure,index) in measureSettings" :key="index">
            <div>
              {{measure.type}}
            </div>
            <div>
              {{measureValues[index]}}
            </div>
            <div style="margin-left: 12px">
              {{measure.in}}
            </div>
          </div>
        </div>
      </div>

  </div>
</template>
<script>
  const VueBootstrapTypeahead = window.VueBootstrapTypeahead

export default {
  name: 'measure-web-component',
  components: {
    VueBootstrapTypeahead,
  },
  props: {
    tool: {
      type: Object,
      required: false,
      default:()=>{}
    },
    focus: {
      type: Object,
      required: false,
      default: () => {
      }
    },
    user: {
      type: String,
      required: false,
      default: () => ""
    },
    typeaheadApps: {
      type: Array,
      default: () => ['Maps','Calculator']
    },
    setTracker: {
      type: Function,
      default: () => () => {}
    },
    setSetting: {
      type: Function,
      default: () => () => {}
    }
  },
  methods:{
    handleAddMeasureSetting() {
      let exist = false
      if(this.tool && this.tool.settings && this.tool.settings.measures) {
        let toCheck = this.tool.settings.measures.map(el => el.type)
        if(toCheck.includes(this.typeToMeasure.toLowerCase())) {
          exist = true
        }
      }
      if(exist) {
        alert(`"${this.typeToMeasure}" already exist`)
      } else {
        let measure = {
          _created_at: new Date(),
          type: this.typeToMeasure.toLowerCase(),
          in: this.measureUnit === 'pound' ? 'lbs' : this.measureUnit === 'feet' ? 'ft' : this.measureUnit
        }
        // this.$store.dispatch('tools/addMeasureSetting', {measure, focusId: this.focus.focusId, tools_id: this.tool.tools_id})
        this.setSetting({measure, focusId: this.focus.focusId, tools_id: this.tool.tools_id})
        .then(() => {
          this.typeToMeasure = ""
          this.measureUnit = ""
          setTimeout(() => {
            this.$refs.typeToMeasure.$data.inputValue = "";
            this.$refs.measureUnit.$data.inputValue = "";  
          }, 200);
        })
      }
    },
    handleSaveTrack() {
      if(this.tool && this.tool.settings && this.tool.settings.measures) {
        let track = {}
        this.tool.settings.measures.forEach((el,index) => {
          track[el.type] = Number(this.measureValues[index])
        })
        track = { _created_at: new Date(), ...track}
        // this.$store.dispatch('tools/addTrackIntoMeasureTool', {track, focusId: this.focus.focusId, tools_id: this.tool.tools_id})
        this.setTracker({track, focusId: this.focus.focusId, tools_id: this.tool.tools_id})
        .then(() => {
          if(this.tool.settings && this.tool.settings.measures) {
            this.measureValues = []
            let lastData = this.tool.tracks.measures[this.tool.tracks.measures.length-1]
          delete lastData._created_at
          
          let arr = []
          for (let key in lastData) {
            arr.push({value: lastData[key], type: key})
          }
          let lastDataValuesSorted = arr.sort(function(a,b) {
              var x = a.type.toLowerCase();
              var y = b.type.toLowerCase();
              if (x < y) {return -1;}
              if (x > y) {return 1;}
              return 0;
          })
          this.tool.settings.measures.forEach((el,index) => {
            if(lastDataValuesSorted[index]) {
              this.measureValues.push(lastDataValuesSorted[index].value)
            } else {
              this.measureValues.push(null)
            }
          })
          }
        })
      }
    }
  },
  computed: {
    unitTypeData() {
      if (this.measureSystem === 'metric') {
        return ['kilogram', 'centimeter']
      } else if (this.measureSystem === 'us') {
        return ['pound','inch']
      } else {
        return []
      }
    },
    measureSettings() {
      if(this.tool && this.tool.settings && this.tool.settings.measures) {
        let a = [...this.tool.settings.measures] 
        a.sort(function(a,b) {
            var x = a.type.toLowerCase();
            var y = b.type.toLowerCase();
            if (x < y) {return -1;}
            if (x > y) {return 1;}
            return 0;
        })
        return a
      } else {
        return []
      }
    }
  },
  mounted() {
    if(this.focus && this.focus.state !== "ondeck") {
      if(this.tool && this.tool.settings && this.tool.settings.measures) {
        this.tool.settings.measures.forEach(el => {
          if(!this.tool.tracks) {
            this.measureValues.push(null)
          }
          this.measureKeys.push(el.type)
        })
      }
      if(this.tool && this.tool.tracks && this.tool.tracks.measures && this.tool.tracks.measures.length) {
        let lastData = this.tool.tracks.measures[this.tool.tracks.measures.length-1]
        delete lastData._created_at
        
        let arr = []
        for (let key in lastData) {
          arr.push({value: lastData[key], type: key})
        }
        let lastDataValuesSorted = arr.sort(function(a,b) {
            var x = a.type.toLowerCase();
            var y = b.type.toLowerCase();
            if (x < y) {return -1;}
            if (x > y) {return 1;}
            return 0;
        })
        let lastDataKeysSorted = this.tool.settings.measures.sort(function(a,b) {
            var x = a.type.toLowerCase();
            var y = b.type.toLowerCase();
            if (x < y) {return -1;}
            if (x > y) {return 1;}
            return 0;
        })
        let onlyType = lastDataValuesSorted.map(el => el.type)
        // this.tool.settings.measures.forEach((el,index) => {
        lastDataKeysSorted.forEach((el,index) => {
          // if(lastDataValuesSorted[index]) {
          if(onlyType.includes(el.type)) {
            this.measureValues.push(lastDataValuesSorted[onlyType.indexOf(el.type)].value)
          } else {
            this.measureValues.push(null)
          }
        })
      }
    }
  },
  data: function() {
    return {
      //state for ondeck view
      measureSystem: "metric",
      typeToMeasure: "",
      measureUnit: "",
      typeToMeasureData: [
        'Height',
        'Weight',
        'Calves'
      ],
      //state for ontack view
      measureValues: [],
      measureKeys: [],
    }
  },
}
</script>
<style lang="scss" module>
  @import './style.module.scss';
</style>
<style scoped>
  .body-card {
    overflow-y: auto;
  }
</style>